(() => {
  'use strict';
  if (window.__KLIK_SHOWROOM_EMBED__ || window.KlikProductionCapture) return;

  function prepare(lines, root, configuration) {
    if (!configuration) return configuration;
    const snapshot = JSON.parse(JSON.stringify(configuration));
    const photo = document.querySelector('meta[property="og:image"]')?.content;
    const group = lines[0]?.properties?._KLIK_capture_group || crypto.randomUUID();
    lines.forEach((line, index) => {
      line.properties = {...line.properties, _KLIK_capture_group: group, _KLIK_design_line: String(index + 1)};
      if (snapshot.family !== 'native-room' && (index === 0 || snapshot.family === 'custom-sofa') && /^https:\/\//.test(photo || '') && !line.properties['_KLIK product reference']) line.properties['_KLIK product reference'] = photo;
    });
    snapshot.orderCaptureVersion = 2;
    snapshot.productHandle = location.pathname.match(/\/products\/([a-z0-9-]+)/)?.[1] || '';
    snapshot.orderLines = lines.map(line => ({id: String(line.id), quantity: Number(line.quantity || 1), ...(Array.isArray(line.nativeSlots) ? {nativeSlots: [...line.nativeSlots]} : {}), properties: Object.fromEntries(Object.entries(line.properties || {}).filter(([key]) => !/^_KLIK_(?:design|capture|build|production)/.test(key)))}));
    // This is existing selection metadata only: no images, textures, uploads or render work.
    return snapshot;
  }

  function attach(lines, root, configuration) {
    if (!lines?.length) return lines;
    for (const line of lines) {
      if (!line.properties) continue;
      for (const key of ['_KLIK_build_id', '_KLIK_build_hash', '_KLIK_build_variant', '_KLIK_production_link']) {
        delete line.properties[key];
      }
    }
    if (lines.some(line => line.properties?._KLIK_design)) return lines;
    const snapshot = prepare(lines, root, configuration || root?.klikShowroom?.captureSelections?.());
    if (!snapshot) return lines;
    const value = JSON.stringify(snapshot);
    if (value.length > 240000) throw Error('This design is too large to save. Reduce the number of separately customised pieces.');
    for (const [index, line] of lines.entries()) {
      line.properties = {
        ...line.properties,
        _KLIK_design_path: location.pathname,
        _KLIK_design_product: String(snapshot.productId)
      };
      if (index === 0) line.properties._KLIK_design = 'j1:' + value;
    }
    return lines;
  }

  window.KlikProductionCapture = Object.freeze({attach, prepare, mode: 'order-options', version: '20261018-auto'});
})();
